module.exports = __webpack_public_path__ + "static/media/bg-help-2112.f51f010b.jpg";